import styled from "styled-components";
import {Link} from 'react-router-dom'

export const Nav = styled.nav`
    background: ${({scrollNav})=>(scrollNav? '#fff':'transparent')};
    box-shadow: 2px 2px 2px 1px rgba(153, 153, 153, 0.1);
    height:70px;
    display:flex;
    justify-content:center;
    align-items:center;
    position:sticky;
    top:0;
    z-index:10;

    @media screen and (max-width: 1044px){
        transition:0.8 all ease;
    }

`;

export const NavbarContainer=styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    height:70px;
    z-index:1;
    width:100%;
    padding:0 24px;
    max-width:1100px;
`;

export const NavLogo=styled.img`
    justify-self:center;
    cursor:pointer;
    display:flex;
    align-items:center;
    height:2.7rem;
    object-fit:contain;
 
`;

export const MobileIcon=styled.div`
    display:none;
    @media screen and (max-width:1044px){
        justify-self:flex-start;
        cursor:pointer;
        display:flex;
        align-items:center;
        position:absolute;
        right:8%;
        color:#0a0a0a;

    }
`;

export const NavMenu=styled.ul`
    display:flex;
    aligh-items:center;
    list-style:none;
    text-align:center;
    margin-right:-22px;

    @media screen and (max-width:1044px){
        display:none;
    }
`;
export const NavItem=styled.li`
    height:70px;
`;

export const NavLinks=styled(Link)`
    color:#0a0a0a;
    font-weight:500;
    font-size:16px;
    display:flex;
    align-items:center;
    text-decoration:none;
    padding:0 1rem;
    height:100%;
    cursor:pointer;

    &:active{
        color: #e9a1b9;
    }
    &:hover{
        color:#e9a1b9;
    }

`;


export const NavBtn=styled.nav`
    display:flex;
    align-items:center;
    @media screen and (max-width:1044px){
        display:none;
    }
`;

export const NavBtnLink=styled(Link)`
    border-radius:2px;
    background:#0a0a0a;
    color: #fff;

    white-space: nowrap;
    padding:0.8rem 1.3rem;

    font-size:0.9rem;
    font-weight: 500;

    outline:none;
    cursor:pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover{
        transition: all 0.2s ease-in-out;
        background:#fff;
        color:#0a0a0a;
        border: 1px solid #0a0a0a;
    }

`;


